import cplook from 'cplook'

$(->
  refreshWidget = (el)->
    mobile = if $(window).width() < cplook.mobilePivot
      1
    else
      0
    $('body').addClass('loading')
    widget = el.closest('.panel').find('.lazy')
    if el.data('field')?
      $(el.data('field')).val(el.data('value'))
    params = el.closest('form').serialize()
    newQuery = "#{widget.data('load')}&mobile=#{mobile}&#{params}"
    widget.data('lastQuery', newQuery)
    widget.load newQuery, ->
      $(this).trigger('dom_updated')

  ## All filter dropdowns
  $(document).on 'change', '.lazy-loaded .form-control.auto-submit', ->
    refreshWidget $(this)
    false

  ## Table dropdowns, user activity search bar
  $(document).on 'click', '.lazy-loaded a.lazy-submit', ->
    refreshWidget $(this)
    false

  ## Navigation
  $(document).on 'click', '.lazy .pagination a', ->
    widget = $(this).closest('.lazy')
    href = $(this).attr('href')
    params = href.substring(href.indexOf('?') + 1)
    url = widget.data('load') + '&' + params
    widget.load url, ->
      $(this).trigger('dom_updated')
    false

  $(document).on 'show.bs.tab', '.chart-switch li', ->
    $('.lazy.delayed').each ->
      $(this).removeClass('delayed')
      $(this).trigger('reload')
)
